<template>
  <FormQuestion
    :header="questionHeader"
    :subtitle="subsidyProgram.preference_subtitle"
    :title="subsidyProgram.preference_title"
    hide-actions
  >
    <v-card
      class="mb-4"
      border
      flat
      tile
    >
      <v-card-title>
        <h4 class="fs-18">
          {{ $bct('Ranked selections') }}
        </h4>
      </v-card-title>

      <v-divider />

      <v-card-text class="px-0 py-0">
        <div class="bg-super-light-blue px-4 py-3">
          <FavoriteCard
            v-for="(providerId, index) in providerIds"
            :key="providerId"
            :index="index"
            :provider-id="providerId"
            class="mb-3"
            hide-toggle
            ordered
            readonly
          />
        </div>
      </v-card-text>
    </v-card>

    <template v-if="subsidyProgram.enable_current_provider_selection">
      <v-card
        border
        flat
        tile
      >
        <v-card-title>
          <h4 class="fs-18">
            {{ $bct('Current Preschool enrollment') }}
          </h4>
        </v-card-title>

        <v-divider />

        <v-card-text class="px-0 py-0">
          <div class="bg-super-light-blue px-4 py-3">
            <template v-if="currentProviderId">
              <SimpleProviderCard
                :api="api"
                :provider-id="currentProviderId"
                hide-toggle
                hide-view-more
              />
            </template>
            <template v-else>
              <p class="fs-16 mb-0">
                {{ $bct('Not currently enrolled at any of the ranked locations.') }}
              </p>
            </template>
          </div>
        </v-card-text>
      </v-card>
    </template>
  </FormQuestion>
</template>

<script setup>
import FavoriteCard from '@/parent/components/favorites/FavoriteCard.vue';
import FormQuestion from '@/shared/components/form/FormQuestion.vue';
import SimpleProviderCard from '@/shared/components/SimpleProviderCard.vue';
import useApi from '@/shared/composables/useApi';

const { api } = useApi();
const $bct = inject('translator');

const props = defineProps({
  childName: {
    type: String,
    default: null,
  },
  currentProviderId: {
    type: String,
    default: null,
  },
  providerIds: {
    type: Array,
    default: null,
  },
  subsidyProgram: {
    type: Object,
    default: null,
  },
});

const questionHeader = computed(() => {
  return `${$bct('Child')} - ${props.childName}`;
});
</script>
